// src/utils/aws_utils.js
import config from '../utils/conf.js'; 

/**
 * Creates the parameters required for uploading a file to S3.
 * @param {Object} userData - The user data object containing origin, UUID, examType, and attemptNumber.
 * @param {Obejct} bodyData - The data to be uploaded.
 * @param {string} filenameSuffix - Suffix for the file name (e.g., "Q6").
 * @param {string} filetype - Type of file corresponding to data (e.g. 'wav')
 * @param {string} content_type - content_type for ContentType header in request body. Ex) 'audio/wav'
 * @returns {Object} The parameters object for S3 upload.
 */
export const createS3UploadParams = (userData, bodyData, filenameSuffix, filetype, content_type) => {
  const fileName = `${config.REACT_APP_BUCKET}/${userData.origin}/${userData.UUID}/${userData.examType}/${userData.attemptNumber}/${filenameSuffix}.${filetype}`;
  const params = {
    Bucket: config.REACT_APP_BUCKET,
    Key: fileName,
    Body: bodyData,
    ContentType: content_type,
  };
  return params;
};

/**
 * Creates the parameters required for uploading a file to S3.
 * @param {Object} userData - The user data object containing origin, UUID, examType, and attemptNumber.
 * @returns {Object} The parameters object for triggering the ACOE scoring process.
 */
export const createAcoeSubmissionParams = (userData) => {
  const url = `${config.COGNET_DB_API_URL}/public/submit_autonocog_json/${userData.UUID}/${userData.origin}/${userData.attemptNumber}`;
  const bodyData = JSON.stringify(JSON.parse(localStorage.getItem("results")));
  console.log("Submitting ACOE to: ", url)
  const params = {
    url: url,
    method: "POST",
    body: bodyData
  }
  return params;
};


// 1) Ask db_api for a presigned URL
// returns
//    data: { upload_url, bucket, key, path, expires_in }
async function getPresignedUrl(baseUrl, patientId, dbName, testType, attempt, { screenId, extension, contentType }) {
  const url = `${baseUrl}/public/request-upload-url/${patientId}/${dbName}/${testType}/${attempt}/${config.REACT_APP_BUCKET}`;
  const payload = { screen_id: screenId, extension: extension, content_type: contentType };
  const response = await fetch(url, {
    method: 'POST',
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  });
  
  if (!response.ok) {
    throw new Error(`Failed to get presigned URL: ${response.statusText}`);
  }
  const presigned_data = await response.json();
  return presigned_data;
}

// 2) Use the presigned URL to PUT the file bytes
async function uploadWithPresigned(presigned_data, fileBuffer, contentType) {
  const resp = await fetch(presigned_data.upload_url, {
    method: 'PUT',
    body: fileBuffer,
    headers: { "Content-Type": contentType },
  });
  if (resp.status !== 200 && resp.status !== 204) {
    throw new Error(`Upload failed with status ${resp.status}`);
  }
}


// 3) Combined helper
export async function uploadToS3V2({ baseUrl, patientId, dbName, testType, attempt, screenId, extension, contentType, fileBuffer }) {
  const presigned_data = await getPresignedUrl(baseUrl, patientId, dbName, testType, attempt, { screenId, extension, contentType });
  await uploadWithPresigned(presigned_data, fileBuffer, contentType);
  return presigned_data
}
